import { h } from 'preact'
import { i18n } from 'i18n/i18n'

interface CalculatorHeaderProps {
  darkMode: boolean
}

const CalculatorHeader = ({ darkMode }: CalculatorHeaderProps) => {
  const logo = darkMode ? 'walutomat-white-wide.svg' : 'walutomat-wide.svg'

  return (
    <div className="calc-widget__header">
      <img
        src={`/wp-content/themes/wt-theme/assets/images/brand/${logo}`}
        alt="Walutomat logo"
        className="calc-widget__logo"
        width={169}
        height={27}
      />
      <h1 className="calc-widget__title">{i18n('widgetCalculator.title', { nbsp: '\u00A0' })}</h1>
    </div>
  )
}

export default CalculatorHeader
